import { Box, SxProps, Theme, Tooltip, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";
import { PropositionTheme } from "../../utils/types";

type Props = {
  theme: PropositionTheme;
  backgroundOpacity?: boolean;
  sx?: SxProps<Theme>;
};

export function ThemeLabel({ theme, backgroundOpacity, sx }: Props) {
  const maxLabelSize = 20;
  const isLabelLarge = theme.name.length >= maxLabelSize;

  function renderLabel() {
    if (isLabelLarge) {
      const label = theme.name.substring(0, maxLabelSize).trim();
      return (
        <Tooltip title={theme.name} className="pressable">
          <Box
            component="span"
            sx={{ display: "inline-flex", alignItems: "center" }}
            style={{ zIndex: -2 }}
          >
            {label}...
            <Info sx={{ fontSize: "1rem", marginLeft: "4px" }} />
          </Box>
        </Tooltip>
      );
    }

    return theme.name;
  }

  return (
    <Box
      sx={[
        {
          backgroundColor: backgroundOpacity ? "#0004" : theme.color,
          borderRadius: "16px",
          padding: "4px 10px",
          width: "fit-content",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        component="span"
        sx={{
          color: "white",
          fontSize: "0.875rem",
          fontWeight: 500,
          lineHeight: 1,
        }}
      >
        {renderLabel()}
      </Typography>
    </Box>
  );
}
